(function() {
  if (window.innerWidth >= 768) return;

  const cards = document.querySelectorAll('.card__media');

  cards.forEach(function(card) {
    const images = card.querySelectorAll('img');
    if (images.length < 2) return;

    const primary = images[0];
    const secondary = images[1];

    secondary.classList.add('card__media-second-image');

    let showingSecondary = false;

    setInterval(function() {
      if (showingSecondary) {
        secondary.classList.remove('is-fading-in');
      } else {
        secondary.classList.add('is-fading-in');
      }
      showingSecondary = !showingSecondary;
    }, 3000);
  });
})();